import {
  FETCH_IMPORT_DETAILS,
  FETCH_IMPORT_DETAILS_SUCCESS,
  FETCH_IMPORT_DETAILS_FAILED,
  SET_SEARCH_IMPORT,
  VALIDATE_FILE,
  VALIDATE_FILE_SUCCESS,
  VALIDATE_FILE_FAILED,
  DOWNLOAD_VALIDATE_FILE,
  DOWNLOAD_VALIDATE_FILE_SUCCESS,
  DOWNLOAD_VALIDATE_FILE_FAILED,
  PROCESS_IMPORT,
  PROCESS_IMPORT_SUCCESS,
  PROCESS_IMPORT_FAILED,
  UPDATE_PROCESS_IMPORT_RESPONSE,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILED,
  DOWNLOAD_SNAPSHOT_FILE,
  DOWNLOAD_SNAPSHOT_FILE_SUCCESS,
  DOWNLOAD_SNAPSHOT_FILE_FAILED,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILED,
} from './import-actions';
import { DEFAULT_GRID_SIZE } from '@med-fe/util';

export const IMPORT_2_STATE_KEY = 'IMPORT_2_REDUCER';

export const defaultSearchImport = {
  page: 0,
  size: DEFAULT_GRID_SIZE,
};

type TState = {
  import: {
    contents: [];
    pages: number;
    total: number;
  };
  search: {
    page: number;
    size: number;
  };
  sorting: {};
  loading: boolean;
  error: any;
  importDetails: any;
  processStatus: boolean;
  resourceFileUploadResponse: any;
  dataValidated: boolean;
  dataProcessed: boolean;
};

const defaultState: TState = {
  import: {
    contents: [],
    pages: 0,
    total: 0,
  },
  search: defaultSearchImport,
  sorting: {
    field: 'officeImportId',
    order: 'desc',
  },
  loading: false,
  importDetails: [],
  error: null,
  processStatus: false,
  resourceFileUploadResponse: null,
  dataValidated: false,
  dataProcessed: false,
};

export const getImport = (state: any) => state[IMPORT_2_STATE_KEY].import;
export const getSearch = (state) => state[IMPORT_2_STATE_KEY].search;
export const getSorting = (state) => state[IMPORT_2_STATE_KEY].sorting;
export const getTotal = (state) => state[IMPORT_2_STATE_KEY]?.import.total || 0;
export const getLoading = (state) => state[IMPORT_2_STATE_KEY].loading;
export const getProcessStatus = (state) => state[IMPORT_2_STATE_KEY].processStatus;
export const getUploadResponse = (state: any) => state[IMPORT_2_STATE_KEY].resourceFileUploadResponse;
export const getImportDetails = (state) => state[IMPORT_2_STATE_KEY].importDetails;
export const getValidateFileLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;
export const getDataValidated = (state: any) => state[IMPORT_2_STATE_KEY].dataValidated;
export const getDownloadValidateFileLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;
export const getProcessImportLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;
export const getDataProcessed = (state: any) => state[IMPORT_2_STATE_KEY].dataProcessed;
export const getDownloadFileLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;
export const getDownloadSnapshotFileLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;
export const getDeleteFileLoading = (state: any) => state[IMPORT_2_STATE_KEY].loading;

export const getImports = (state) =>
  state[IMPORT_2_STATE_KEY]?.import.contents.map((item: any) => ({
    ...item,
    key: item.id,
  }));

export const importReducer = (state = defaultState, { type, payload, dataValidated, dataProcessed, loading }: any) => {
  switch (type) {
    case FETCH_IMPORT_DETAILS: {
      return {
        ...state,
        loading: true,
        dataValidated: false,
        dataProcessed: false,
      };
    }
    case FETCH_IMPORT_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        import: payload,
      };
    }
    case FETCH_IMPORT_DETAILS_FAILED: {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    }
    case SET_SEARCH_IMPORT: {
      return {
        ...state,
        search: { ...state.search, ...payload },
      };
    }
    case VALIDATE_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case VALIDATE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        dataValidated: dataValidated,
      };
    }
    case VALIDATE_FILE_FAILED: {
      return {
        ...state,
        loading: false,
      };
    }
    case DOWNLOAD_VALIDATE_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DOWNLOAD_VALIDATE_FILE_FAILED:
    case DOWNLOAD_VALIDATE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case PROCESS_IMPORT: {
      return {
        ...state,
        loading: true,
      };
    }
    case PROCESS_IMPORT_FAILED: {
      return {
        ...state,
        loading: false,
      };
    }
    case PROCESS_IMPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        dataProcessed: dataProcessed,
      };
    }
    case DOWNLOAD_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DOWNLOAD_FILE_FAILED:
    case DOWNLOAD_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case DOWNLOAD_SNAPSHOT_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DOWNLOAD_SNAPSHOT_FILE_FAILED:
    case DOWNLOAD_SNAPSHOT_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case DELETE_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DELETE_FILE_FAILED:
    case DELETE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};
